<template>
<base-modal :modal-title="'Edit Rule'" @save="save()" @close="close">
  <FormulateForm>
    <FormulateInput type="checkbox" v-model="model.active" label="Active" />
    <FormulateInput type="select" v-model="model.scoring_model_id" label="Scoring Model" validation="required" :options="scoringModelsOptions" />
    <FormulateInput type="select" v-model="model.test_scoring_models_ids" label="Test Scoring Models" multiple="true" :options="testScoringModelsOptions" />
    <FormulateInput type="range" v-model="model.rate" label="Rate" min="0" max="100" validation="required|min:0|max:100" show-value="true" />
  </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build.
 var _ = require('lodash');
 import BaseModal from 'components/modals/BaseModal';

 export default {
   components: {
     BaseModal
   },
   props: {
     filter: {
       type: Object,
       default () {
         return {
             id: null,
             active: false,
             rate: 100,
             predicate: {'allof': {'terms': []} },
             scoring_model_id: null,
             scoring_model: {
                 id: null,
                 name: null
             },
             test_scoring_models: [],
             test_scoring_models_ids: []
         };
       }
     },
   },
   data () {
     return {
         model: null,
         scoringModels: {},
         scoringModelsOptions: []
     };
   },
    created () {
      this.model = _.clone(this.filter, true);
      if (this.model['id'] == null) {
        this.model.id = this.randomId();
        this.model.is_new = true;
      }
      else {
        this.model.is_new = false;
      }
      this.fetchScoringModels();
    },
    computed: {
      testScoringModelsOptions() {
        return this.scoringModelsOptions.filter(m => m.value != this.model.scoring_model_id);
      }
    },
    methods: {
      close() {
           this.$emit('close', true);
      },
      save() {
        this.model.scoring_model = this.model.scoring_model_id ?
                                   {id: this.model.scoring_model_id, name: this.scoringModels[this.model.scoring_model_id]} :
                                   {id: null, name: null};
        this.model.test_scoring_models = this.model.test_scoring_models_ids.map(mid => { return {id: mid, name: this.scoringModels[mid]}});
        this.$emit('save', this.model);
       },
      randomId() {
        var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
        var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
        return "temp_" + r1 + "_" + r2;
      },
      fetchScoringModels() {
        var self = this;
        API.scoringModels.getList()
           .then((response) => {
                  _.forEach(
                    response.body,
                    (item) => {
                      if (item.id !== '__default__') {
                        self.scoringModels[item.id] = item.name;
                        self.scoringModelsOptions.push({
                          value: item.id,
                          label: item.name
                        });
                      }
                    }
                  );
           });
      }
   }
  }
</script>


<style>
 .form-dashboard .select2-container {
   width: 100% !important;
 }
 .form-dashboard #reportrange {
   background: rgb(255, 255, 255);
   cursor: pointer;
   padding: 5px 10px;
   border: 1px solid rgb(204, 204, 204);
   display: inline-block;
 }
 .form-dashboard .select2-container--default .select2-selection--single .select2-selection__rendered {
   padding: 6px 12px;
   height: 34px;
   line-height: 1.42857143;
 }
 .form-dashboard .select2-container .select2-selection--single {
   height: 34px;
   border: 1px solid #ccc;
   border-radius: 4px;
 }
 .form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow {
   position: absolute;
   top: 35%;
   margin-top: -8px;
   right: .5em;
 }
 .form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow b {
   border-color: #616161 transparent transparent transparent;
 }
 .form-dashboard .comiseo-daterangepicker-triggerbutton.ui-button {
   width: 100%;
   height: 34px;
   padding: 6px 12px;
   font-size: 14px;
   line-height: 1.42857143;
   color: #555;
   background-color: #fff;
   background-image: none;
   border: 1px solid #ccc;
   border-radius: 4px;
 }
 .form-dashboard .dropdown-toggle-filters {
   width: 100%;
   text-align: left;
 }
 .form-dashboard .dropdown-toggle-filters .caret {
   float: right;
   margin: 8px 0;
   color: #616161;
 }

 h3 {
   width: 100%;
   display: inline-block;
 }
 h3 .btn {
   position: sticky;
   left: 100%;
   margin-top: -7px;
   font-size: 1rem!important;
 }
 .formulate-input-element-range-value::after {
   content: '%';
 }
</style>



// WEBPACK FOOTER //
// ScoringModelRuleModal.vue?f474bdd8